import { Component, Input, ViewChild, ElementRef, AfterViewChecked, OnChanges, SimpleChanges } from '@angular/core';

import { ChatMessageComponent } from './chat-message.component';
import { Message } from '../interfaces/chat-clip-rep.interface';

@Component({
  selector: 'app-chat-messages-list',
  standalone: true,
  imports: [ChatMessageComponent],
  template: `
    <div class="h-full overflow-y-auto p-2 sm:p-3 lg:p-4 bg-gray-50 chat-messages" #messagesContainer>
      <!-- Mensaje de estado del pedido -->
      <div class="text-center mb-3 sm:mb-4 lg:mb-6">
        <div class="inline-block bg-gray-200 text-gray-600 px-2 sm:px-3 py-1 rounded-full text-xs">
          Tu pedido está siendo preparado
        </div>
      </div>

      <!-- Lista de mensajes -->
      <div class="space-y-2 sm:space-y-3 pb-2 sm:pb-4">
        @for (message of messages; track $index) {
          <app-chat-message [message]="message"></app-chat-message>
        }
      </div>

      <!-- Indicador de escritura -->
      @if (isTyping) {
        <div class="flex justify-start mt-2 sm:mt-3">
          <div class="bg-gray-200 text-gray-800 px-3 sm:px-4 py-2 rounded-lg rounded-bl-sm max-w-xs">
            <div class="flex space-x-1 items-center">
              <span class="text-xs text-gray-600 mr-1 sm:mr-2">Escribiendo</span>
              <div class="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-gray-500 rounded-full animate-bounce"></div>
              <div class="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-gray-500 rounded-full animate-bounce" style="animation-delay: 0.1s"></div>
              <div class="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-gray-500 rounded-full animate-bounce" style="animation-delay: 0.2s"></div>
            </div>
          </div>
        </div>
      }
    </div>
  `
})
export class ChatMessagesListComponent implements AfterViewChecked, OnChanges {
  @Input() messages: Message[] = [];
  @Input() isTyping: boolean = false;
  @ViewChild('messagesContainer', { static: false }) messagesContainer!: ElementRef;
  
  private shouldScrollToBottom = false;
  private previousMessageCount = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['messages'] && this.messages) {
      // Si hay nuevos mensajes, marcar para hacer scroll
      if (this.messages.length > this.previousMessageCount) {
        this.shouldScrollToBottom = true;
      }
      this.previousMessageCount = this.messages.length;
    }
  }

  ngAfterViewChecked() {
    if (this.shouldScrollToBottom) {
      this.scrollToBottom();
      this.shouldScrollToBottom = false;
    }
  }

  scrollToBottom(): void {
    try {
      if (this.messagesContainer) {
        const element = this.messagesContainer.nativeElement;
        // Usar smooth scroll para una mejor experiencia de usuario
        element.scrollTo({
          top: element.scrollHeight,
          behavior: 'smooth'
        });
      }
    } catch (err) {
      console.error('Error al hacer scroll:', err);
    }
  }

  // Método para marcar que se debe hacer scroll en el próximo ciclo
  markForScrollToBottom(): void {
    this.shouldScrollToBottom = true;
  }
}
